import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../../components/home/discounted.css";

const Recommended = ({ category }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const fetchItems = async () => {
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await fetch(
          `${backendURL}products/discounted-home`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setItems(data.items);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [category]);

  return (
    <section className="text-size-feat py-0 mb-24 mt-24 dark:bg-gray-900">
      <div className="mx-auto max-w-8xl md:px-20 lg:px-20">
        <div className="mb-8 flex items-center justify-between">
          <h2 className="font-bold text-gray-900 dark:text-white md:text-2xl">
            Recommended For You
            <span className="block h-1 w-16 secondary-color mt-1" />
          </h2>
          <div className="flex space-x-4">
            <button
              onClick={scrollLeft}
              className="bg-white dark:bg-gray-800 p-2 dark:hover:bg-gray-700 transition-colors"
            >
              <svg
                className="h-6 w-6 text-gray-700 dark:text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <button
              onClick={scrollRight}
              className="bg-white dark:bg-gray-800 p-2 dark:hover:bg-gray-700 transition-colors"
            >
              <svg
                className="h-6 w-6 text-gray-700 dark:text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
        {loading ? (
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-[3/4] bg-gray-200 dark:bg-gray-700 rounded-xl" />
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded mt-4 w-3/4" />
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded mt-3 w-1/3" />
              </div>
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600 dark:text-gray-400 text-lg">
              No items found
            </p>
          </div>
        ) : (
          <div ref={scrollContainerRef} className="overflow-x-auto scrollbar-hide">
            <div className="grid grid-flow-col gap-24 auto-cols-[minmax(200px,1fr)]">
              {items.map((item) => (
                <Link
                  key={item.id}
                  to={`/product/${item.id}`}
                  state={{
                    product: {
                      ...item,
                      // Transform raw image data so that the product object has an `images` property
                      images: {
                        light: item.image, // assuming item.image is an array of strings
                        dark: item.imageHover, // if available
                      },
                    },
                  }}
                >
                  <div className="group relative transition-transform duration-200 ease-in-out hover:scale-[1.02]">
                    <div className="w-[270px] h-[340px] overflow-hidden relative">
                      <img
                        className="w-full h-full object-cover transform transition duration-500 ease-in-out group-hover:scale-110"
                        src={item.image[0]}
                        alt={item.title}
                        onMouseOver={(e) =>
                          item.imageHover &&
                          (e.currentTarget.src = item.imageHover)
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.src = item.image[0])
                        }
                      />
                      {item.tags && (
                        <div className="absolute top-2 right-2 bg-white text-brown px-2 py-1 text-sm uppercase tracking-wide">
                          {item.tags}
                        </div>
                      )}
                    </div>
                    <div className="mt-4 space-y-1">
                      <h3 className="text-gray-900 dark:text-white line-clamp-2">
                        {item.title}
                      </h3>
                      <span>${item.price}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Recommended;
